<template>
    <div class="login-container flex-center-hori">
        <div class="login-box-wrapper">
            <div class="login-title">欢迎使用佳都知行助手</div>
            <div class="login-box">
                <div class="login-top flex-center-hori">
                    <div class="login-top-text">用户登录</div>
                </div>
                <div class="login-mid">
                    <div class="input-note">用户名</div>
                    <div class="input-wrapper">
                        <el-input type="text" v-model="username" placeholder="请输入用户名"></el-input>
                    </div>
                    <div class="input-note">密码</div>
                    <div class="input-wrapper">
                        <img class="show-password"
                            :src="showPass? require('@/theme/images/icons/icon_eye_hidden.svg'):require('@/theme/images/icons/icon_eye_outline.svg') "
                            @click="showPass = !showPass">
                        <el-input class="password-input"
                            :type="showPass ? 'text' : 'password'"
                            v-model="password"
                            placeholder="请输入密码"
                            @keyup.enter.native="login"></el-input>
                    </div>
                    <div class="agreement">
                        <el-checkbox v-model="agree">我已阅读并同意<span class="link" @click="gotoServiceAgreement">服务协议</span>与<span class="link" @click="gotoPrivacyPolicy">隐私政策</span></el-checkbox>
                        <!--                        <span class="link" @click="gotoForgetPasswoed">忘记密码？</span>-->
                    </div>
                    <div class="input-note warn" v-if="agreeErr">请勾选“阅读并接受用户协议”</div>
                    <div class="input-note warn" v-if="loginErr && !agreeErr">{{loginErrText || '登录失败，请重试'}}</div>
                </div>
                <div class="login-bottom">
                    <div class="login-button flex-center-hori" @click="login">
                        <div v-if="!logining">登录</div>
                        <div v-else>登录中...</div>
                    </div>
                    <!--                    <div @click="gotoRegister" class="link">注册账号</div>-->
                    <img :src="require('@/theme/images/login_hero_logo.png')">
                </div>
            </div>
        </div>
        <changePassword ref="changePassword"/>
    </div>
</template>

<script>
import SwitchBar from '../../components/ui/SwitchBar.vue';
import changePassword from './change-password';
import { formatLoginParams } from '../../../utils/ssoLogin';
import { accountApi } from '../../../apiAxios/modules/account.api';
export default {
    name: 'login',
    components: { SwitchBar, changePassword },
    data () {
        return {
            username: '',
            password: '',
            showPass: false,
            logining: false,
            loginErr: false,
            loginErrText: '',
            agree: false,
            agreeErr: false
        };
    },
    computed: {
        isDark () {
            return this.$store.state.appSettings.isDark;
        }
    },
    methods: {
        async login () {
            if (!this.agree) {
                this.agreeErr = true;
                return;
            } else {
                this.agreeErr = false;
            }
            this.logining = true;
            this.loginErr = false;
            let result;
            try {
                result = await accountApi.ssoLogin(formatLoginParams(this.username, this.password));
                if (+result.OpCode !== 0) {
                    // 1001为首次登录需重置密码； 1002为账户密码已过有效期需修改密码
                    if (+result.OpCode === 1001 || +result.OpCode === 1002) {
                        let restType = 1;
                        if (+result.OpCode === 1002) {
                            restType = 2;
                        }
                        this.$refs.changePassword.showDialog(this.username, restType);
                        this.$nextTick(() => {
                            this.$message.warning(result.OpDesc);
                        });
                    } else {
                        this.loginErrText = result.OpDesc;
                    }
                    throw new Error(result.OpDesc);
                }
            } catch (error) {
                this.logining = false;
                this.loginErr = true;
                console.error(error);
                return;
            }
            this.$store.commit('account/setToken', result.Data.token);
            await this.$store.dispatch('account/getUserInfo');
            this.logining = false;
            this.toMain();
        },
        toMain () {
            setTimeout(() => {
                this.$router.replace('/call');
            }, 10);
        },
        // 打开服务协议
        gotoServiceAgreement () {

        },
        // 打开隐私政策
        gotoPrivacyPolicy () {

        },
        // 打开忘记密码
        gotoForgetPasswoed () {

        },
        // 打开注册账号
        gotoRegister () {
            this.$router.replace({ path: '/signup' });
        }
    }
};
</script>
<style scoped lang="scss">
.login-container {
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    flex-flow: row nowrap;
    background: url(~@/theme/images/bg_login_light.png);
    background-size: cover;

    .login-box-wrapper {
        display: flex;
        flex-flow: column nowrap;
        align-items: center;

        .login-title {
            font-size: 40px;
            margin: 16px 0;
            font-family: SourceHanSansSC-Bold, SourceHanSansSC;
            font-weight: bold;
            color: #3B77FF;
            line-height: 56px;
            background: linear-gradient(270deg, #165DFF 0%, #209BFF 100%);
            background-clip: text;
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
        }

        .login-box {
            width: 480px;
            height: 564px;
            margin: 6px 0;
            border-radius: 8px;
            background: #FFFFFF linear-gradient(180deg, #F2F7FF 0%, #FFFFFF 100%);
            box-shadow: 0px 2px 6px 0px rgba(7, 22, 51, 0.06);
            border: 2px solid;
            border-image: linear-gradient(180deg, rgba(255, 255, 255, 0.8), rgba(255, 255, 255, 0)) 2 2;
            display: flex;
            flex-flow: column nowrap;
            align-items: center;
            justify-content: space-between;

            .login-top,
            .login-bottom {
                width: 100%;
                flex: 0 0 auto;
            }

            .login-top>.login-top-text {
                font-size: 24px;
                font-family: PingFang SC-Medium, PingFang SC, SourceHanSansSC-Medium, SourceHanSansSC, Microsoft Yahei;
                font-weight: 500;
                line-height: 30px;
                margin: 32px 0 12px;
                color: rgba(7, 22, 51, 0.85);
            }

            .login-mid {
                flex: 1 1 auto;

                .input-note {
                    color: rgba(7, 22, 51, 0.85);
                    width: 400px;
                    height: 27px;
                    margin: 24px 0 4px;
                    text-align: left;
                    font-size: 16px;
                    line-height: 24px;
                }

                .input-note.warn {
                    margin: 12px 0 8px;
                    font-size: 14px;
                    color: red;
                }

                .input-wrapper {
                    position: relative;

                    .show-password {
                        z-index: 1;
                        height: 16px;
                        margin: 16px;
                        position: absolute;
                        right: 0;
                        top: 0;
                        cursor: pointer;
                    }
                }

                ::v-deep{
                    .el-input__inner{
                        font-size: 16px;
                        height: 48px;
                    }
                    .el-input__inner:focus{
                        border: 1px solid #126CFF;
                    }
                }

                .agreement{
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    margin: 24px 0;
                    ::v-deep{
                        .el-checkbox{
                            &__label{
                                cursor: default;
                                color: rgba(7, 22, 51, 0.45);
                            }
                        }
                    }
                }
            }

            .login-bottom {
                display: flex;
                flex-flow: column nowrap;
                align-items: center;

                .login-button {
                    width: 400px;
                    height: 48px;
                    background: #126CFF;
                    border-radius: 4px;
                    user-select: none;
                    cursor: pointer;
                    margin-bottom: 8px;

                    >div {
                        font-size: 16px;
                        font-family: PingFang SC-Medium, PingFang SC, SourceHanSansSC-Medium, SourceHanSansSC, Microsoft Yahei;
                        font-weight: 500;
                        color: #FFFFFF;
                        line-height: 30px;
                        letter-spacing: 4px;
                    }
                }

                >img {
                    width: 223px;
                    // filter: brightness(0.6);
                    margin: 40px 0;
                    // opacity: 0.8;
                }

                .switch-dark {
                    user-select: none;
                    width: 100%;
                    padding: 15px;
                    box-sizing: border-box;
                    border-top: 1px solid rgba(128, 128, 128, 0.6);
                }
            }

            .link{
                font-size: 14px;
                color: rgba(18, 108, 255, 1) ;
                cursor: pointer;
                &:hover{
                    text-decoration: underline;
                }
            }
        }

    }
}</style>
